<div *ngIf="showHeader" class="header-container">
    <global-message></global-message>
    <preheader></preheader>
    <div id="usanaShopHeader">
        <div class="shopHeader">
            <div class="shopHeader--nav top">
                <div class="shopHeader--navItem logo">
                    <a class="navLogo d-none d-md-block" [ngClass]="{'baoying-logo': showBaoying}" [routerLink]="[DOTCOM_HOME_ROUTE]"
                       aria-label="USANA">
                        <img id="usanaLogoTagLine" src="{{logoUrl}}" alt="" aria-hidden="true">
                    </a>
                    <!--                    Mobile menu hamburger icon-->
                    <div class="iconBtn d-md-none " [attr.aria-label]="'cart.mobile.main.menu' | translate" (click)="setMobileNav()">
                        <i class="fa-solid fa-bars"></i>
                    </div>

                    <div class="usanaSearch" *ngIf="!limitedShopGroup">
                        <quick-search (selectedProduct)="searchItemSelected($event)" [warehouse]="currentWarehouse"
                                      [includePacks]="true"
                                      resultLayout="header"></quick-search>
                    </div>
                    <!--                    Mobile menu logo img-->
                    <a class="mobile-header-logo d-md-none" [routerLink]="[DOTCOM_HOME_ROUTE]"
                       aria-label="USANA">
                        <img src="{{mobileHeaderLogoUrl}}" alt="" aria-hidden="true">
                    </a>
                    <div class="text-right">
                        <span class="navLink sponsor d-none d-md-block" *ngIf="displaySponsorDetails && !showCartPriceBreakdown">
                            <sup translate="cart.sponsor.title"></sup>
                            <a *ngIf="!!sponsorDetails.siteUrl" href="{{sponsorDetails.siteUrl}}">
                                <span>{{sponsorName | limitToWithEllipse: 15}}</span>
                            </a>
                            <span *ngIf="!sponsorDetails.siteUrl">{{sponsorName}}</span>
                        </span>
                            <span class="navLink emp" *ngIf="displayLoginButton">
                            <a href="javascript:void(0)" class="text-uppercase" (click)="login()"
                               translate="cart.login"></a>
                        </span>

                        <span class="navLink emp d-none d-md-block" *ngIf="showDotcomHubLink">
                            <a [href]="getHubLink()" class="text-uppercase" [attr.data-testid]="'hub-link'">{{ 'the-hub' | i18n: 'usanadotcom' }}</a>
                        </span>

                        <span class="navLink userDropDown d-none d-md-block" dropdown *ngIf="authenticated && !showDotcomHubLink"
                              (click)="closeAllAlerts()">
                        <a href="javascript:void(0)" class="text-uppercase" dropdownToggle
                           id="menubutton" aria-controls="menu" [attr.data-testid]="'cart.user.dropdown'">
                            {{welcomeName}}
                            <i class="fa-solid fa-chevron-down"></i>
                        </a>
                        <ul *dropdownMenu role="menu" class="dropdown-menu" aria-labelledby="menubutton">
                            <li *ngIf="employee">
                                <a [routerLink]="ADMIN_ROUTE" class="dropdown-menu-top" role="menuitem">
                                    <span class="user-dropdown-option">Admin</span>
                                </a>
                            </li>
                             <li *ngIf="affiliate && !eventShopping">
                                <a [routerLink]="AFFILIATE_DASHBOARD_ROUTE"
                                   [attr.data-testid]="'cart.affiliate.dashboard'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.affiliate.dashboard"></span>
                                </a>
                            </li>
                            <li *ngIf="canEditAutoOrderOnline || canAddAutoOrderOnline">
                                <a [routerLink]="nfrMhpShoppingOnly ? [MHP_SELECT_ROUTE] : [AUTO_ORDER_MANAGE_ROUTE]"
                                   class="dropdown-menu-top" [attr.data-testid]="'cart.manage.ao'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.manage.ao"></span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="ORDER_HISTORY_ROUTE" [attr.data-testid]="'cart.order.history'"
                                   role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.order.history"></span>
                                </a>
                            </li>
                            <li *ngIf="showReferralCreditProgram">
                                <a [routerLink]="[REFERRAL_CREDIT_ROUTE]" [queryParams]="{clear: true}"
                                   [attr.data-testid]="'cart.referral.credits'" role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.referral.credits"></span>
                                </a>
                            </li>
                            <li *ngIf="showFbShareables || showUrlShareables">
                                <a [routerLink]="SHARE_LIST_ROUTE" [attr.data-testid]="'cart.manage.share.lists'"
                                   role="menuitem">
                                    <span class="user-dropdown-option" translate="cart.manage.share.lists"></span>
                                </a>
                            </li>
                            <ng-container *ngIf="preferredCustomer || affiliate">
                                <li>
                                    <a [href]="getPersonalInfoLink()" target="_blank"
                                       [attr.data-testid]="'cart.personal.information'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.personal.information"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="affiliate">
                                <li>
                                    <a [href]="getTaxInfoLink()" target="_blank"
                                       [attr.data-testid]="'cart.tax.information'">
                                        <span class="user-dropdown-option" translate="cart.tax.information"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="preferredCustomer || affiliate">
                                <li>
                                    <a [href]="getNotificationLink()" target="_blank"
                                       [attr.data-testid]="'cart.customer.notification'" role="menuitem">
                                        <span class="user-dropdown-option"
                                              translate="cart.customer.notification"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="affiliate">
                                 <li>
                                    <a [href]="getAffiliateOrderHistoryLink()" target="_blank"
                                       [attr.data-testid]="'cart.customer.order.history'" role="menuitem">
                                        <span class="user-dropdown-option"
                                              translate="cart.customer.order.history"></span>
                                    </a>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="preferredCustomer">
                                <li>
                                    <a [href]="getReturnsLink()" target="_blank"
                                       [attr.data-testid]="'cart.customer.returns'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.customer.returns"></span>
                                    </a>
                                </li>
                            </ng-container>
                                <li *ngIf="showNfrLink">
                                    <a [href]="getNfrLink()" target="_blank"
                                       [attr.data-testid]="'cart.customer.nfr'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.customer.nfr"></span>
                                    </a>
                                </li>
                                <li *ngIf="showGoToHub">
                                    <a [href]="getHubLink()" target="_blank" [attr.data-testid]="'cart.goto.hub'"
                                       role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.goto.hub"></span>
                                    </a>
                                </li>
                                <li *ngIf="chinaCustomer">
                                    <a (click)="goToContactCustomer()"
                                       [attr.data-testid]="'cart.contact.customer.service'" role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.contact.customer.service"></span>
                                    </a>
                                </li>
                                <li class="border-top">
                                    <a [routerLink]="LOGOUT_ROUTE" [attr.data-testid]="'cart.enroll.logout'"
                                       role="menuitem">
                                        <span class="user-dropdown-option" translate="cart.enroll.logout"></span>
                                    </a>
                                </li>
                            </ul>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="authenticated">
                            <ao-dropdown [(aoDropdownDisabled)]="aoDropdownDisabled"></ao-dropdown>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="showCart">
                            <cart-icon></cart-icon>
                        </span>
                        <span class="navLink d-none d-md-block" *ngIf="displayLocaleSwitcherButton">
                            <a href="javascript:void(0)" (click)="openLocaleSwitcher()" class="btn btn-link locale">
                                <flag-icon [localeCountry]="userCountry"></flag-icon>
                                <span>{{userLanguage}}</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="shopHeader--nav bottom d-none d-md-block">
                <div class="navLink">
                    <dotcom-nav-menu></dotcom-nav-menu>
                </div>
            </div>
            <div class="shopHeader--nav nfr-banner" *ngIf="nfrShopping || nfrMhpShoppingOnly">
                <a href="javascript:void(0)" (click)="openExitNfrDialog()"><span
                    translate="cart.exit.nfr.banner"></span></a>
            </div>
            <div class="shopHeader--nav nfr-banner" *ngIf="employee">
                <a href="javascript:void(0)" (click)="toggleEmployeePriceType()"
                   [translate]="payingWithUsanaBucks ? 'cart.employee.switchpayment.personal' : 'cart.employee.switchpayment.usanabucks'"></a>
            </div>
            <div class="shopHeader--nav event-banner" *ngIf="eventShoppingEligible">
                <a href="javascript:void(0)" (click)="toggleEventShopping()"
                   [translate]="eventShopping ? 'cart.exit.event.shopping.banner' : 'cart.enter.event.shopping.banner'"></a>
            </div>
        </div>

        <!--side menu for mobile -->
        <div class="shopSideNav" [hidden]="!isSideMenuOpen">
            <div class="shopSideNav-header">
                <a class="navLogoText" (click)="isSideMenuOpen=false"
                   [routerLink]="homeLinkEnabled ? [LANDING_ROUTE] : null" aria-label="USANA">
                    <img id="usanaLogoText" src="{{mobileSideMenuLogoUrl}}" alt="" aria-hidden="true">
                </a>
                <button type="button" class="close fa-solid fa-xmark pull-right" [attr.aria-label]="'cart.button.close'| translate" (click)="isSideMenuOpen=false">
                </button>
            </div>

            <side-nav-account-switcher [sponsorName]="sponsorName" [displaySponsorDetails]="displaySponsorDetails && !showCartPriceBreakdown"
                                       (closeSideMenu)="isSideMenuOpen=false"></side-nav-account-switcher>

            <dotcom-mobile-nav-menu (closeSideMenu)="isSideMenuOpen=false"></dotcom-mobile-nav-menu>

            <hr>
            <!--bottom-->
            <div class="shopSideNav-bottom">
                <div class="bottom-item" *ngIf="affiliate && !eventShopping">
                    <a (click)="isSideMenuOpen=false" [routerLink]="AFFILIATE_DASHBOARD_ROUTE"
                       [attr.data-testid]="'mobile.cart.affiliate.dashboard'">
                        <span translate="cart.affiliate.dashboard"></span> <span
                        class="status-badge status-blue margin-left-8" translate="cart.status.badge.new"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="canEditAutoOrderOnline || canAddAutoOrderOnline">
                    <a (click)="isSideMenuOpen=false"
                       [routerLink]="nfrMhpShoppingOnly ? [MHP_SELECT_ROUTE] : [AUTO_ORDER_MANAGE_ROUTE]"
                       [attr.data-testid]="'mobile.cart.manage.ao'">
                        <span translate="cart.manage.ao"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="ORDER_HISTORY_ROUTE"
                       [attr.data-testid]="'mobile.cart.order.history'">
                        <span translate="cart.order.history"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="showReferralCreditProgram">
                    <a (click)="isSideMenuOpen=false" [routerLink]="[REFERRAL_CREDIT_ROUTE]"
                       [queryParams]="{clear: true}" [attr.data-testid]="'mobile.cart.referral.credits'">
                        <span translate="cart.referral.credits"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="(showFbShareables || showUrlShareables) && authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="SHARE_LIST_ROUTE"
                       [attr.data-testid]="'mobile.cart.manage.share.lists'">
                        <span translate="cart.manage.share.lists"></span>
                    </a>
                </div>
                <ng-container *ngIf="preferredCustomer || affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getPersonalInfoLink())" href="javascript:void(0)"
                           [attr.data-testid]="'mobile.cart.personal.information'">
                            <span translate="cart.personal.information"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getTaxInfoLink())" href="javascript:void(0)"
                           [attr.data-testid]="'mobile.cart.tax.information'">
                            <span translate="cart.tax.information"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="preferredCustomer || affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getNotificationLink())" href="javascript:void(0)"
                           [attr.data-testid]="'mobile.cart.customer.notification'">
                            <span translate="cart.customer.notification"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="affiliate">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getAffiliateOrderHistoryLink())" href="javascript:void(0)"
                           [attr.data-testid]="'mobile.cart.customer.order.history'">
                            <span translate="cart.customer.order.history"></span>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="preferredCustomer">
                    <div class="bottom-item">
                        <a (click)="mobileNavigateTo(getReturnsLink())" href="javascript:void(0)"
                           [attr.data-testid]="'mobile.cart.customer.returns'">
                            <span translate="cart.customer.returns"></span>
                        </a>
                    </div>
                </ng-container>

                <div class="bottom-item" *ngIf="showGoToHub">
                    <a (click)="mobileNavigateTo(getHubLink())" href="javascript:void(0)"
                       [attr.data-testid]="'mobile.cart.goto.hub'">
                        <span translate="cart.goto.hub"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="chinaCustomer">
                    <a (click)="isSideMenuOpen=false; goToContactCustomer()"
                       [attr.data-testid]="'mobile.cart.contact.customer.service'">
                        <span translate="cart.contact.customer.service"></span>
                    </a>
                </div>
                <div class="bottom-item border-top" *ngIf="authenticated">
                    <a (click)="isSideMenuOpen=false" [routerLink]="LOGOUT_ROUTE"
                       [attr.data-testid]="'cart.enroll.logout'">
                        <span translate="cart.enroll.logout"></span>
                    </a>
                </div>
                <div class="bottom-item" *ngIf="displayLocaleSwitcherButton">
                    <a (click)="openLocaleSwitcher()">
                        <flag-icon [localeCountry]="userCountry"></flag-icon>
                        <span>{{userLanguage}}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="shopSideNav-overlay" [hidden]="!isSideMenuOpen" (click)="isSideMenuOpen=false"></div>
    </div>
    <account-switcher></account-switcher>
</div>
